import api from '.';

import { returnLoggedInUserRole } from '../../Utils/index';
import LocalStorageManager from '../../Utils/localstorage';

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    registerUser: builder.mutation({
      query: ({ data, token }) => {
        return {
          url: `/sign-up/${token ? token : 'undefined'}`,
          method: 'POST',
          body: data
        };
      }
      // transformResponse: (res) => {
      //   const { user, tokens, orgRoles } = res;
      //     returnLoggedInUserRole(orgRoles);
      //
      //   return {
      //     user,
      //     tokens,
      //     isAdmin,
      //     isSuperAdmin,
      //     isProviderAdmin,
      //     organizationId
      //   };
      // }
    }),
    loginUser: builder.mutation({
      query: (data) => ({
        url: '/login',
        method: 'POST',
        body: data
      }),
      transformResponse: (res) => {
        const { token, refreshToken } = res;
        // const { isAdmin, isSuperAdmin, isProviderAdmin, organizationId } = returnLoggedInUserRole(userProfile);
        LocalStorageManager.set('evChAccessToken', token);
        LocalStorageManager.set('evChRefreshToken', refreshToken);

        return {
          tokens: res
        };
      }
    }),
    getMe: builder.query({
      query: () => ({
        url: '/me'
      }),
      transformResponse: (res) => {
        return {
          userProfile: res
        };
      }
    }),

    getUserRole: builder.query({
      query: (id, filter) => ({
        url: `/users/${id}/roles`,
        method: 'GET',
        params: { filter }
      }),

      transformResponse: (res) => {
        const { isAdmin, isSuperAdmin } = returnLoggedInUserRole(res);

        return {
          isAdmin,
          isSuperAdmin
        };
      }
    }),
    autoLoginUser: builder.mutation({
      query: (data) => ({
        url: '/auto-login',
        method: 'POST',
        body: data
      }),

      transformResponse: (res) => {
        const { tokens } = res;
        if (tokens && Object.keys(tokens).length > 0) {
          return {
            tokens
          };
        }
      }
    }),
    getUserDetails: builder.query({
      query: () => ({
        url: '/users/get-user-details'
      }),
      transformResponse: (res) => {
        const { user, orgRoles, providerOrgs } = res;
        const { isAdmin, isSuperAdmin, isProviderAdmin, organizationId } =
          returnLoggedInUserRole(orgRoles);
        return {
          user,
          isAdmin,
          isSuperAdmin,
          isProviderAdmin,
          organizationId,
          providerOrgs
        };
      }
    })
  })
});
export default authApi;
export const {
  useLazyGetMeQuery,
  useLazyGetUserRoleQuery,
  useRegisterUserMutation,
  useLoginUserMutation,
  useAutoLoginUserMutation,
  useGetUserDetailsQuery
} = authApi;
